export default () => {
	const form = document.querySelector('.gw');
	if (!form) return;

	const checkbox = form.querySelector('.js-gw-checkbox');
	const add = form.querySelector('.js-gw-add');
	const save = form.querySelector('.js-gw-save');
	const close = form.querySelector('.js-gw-close');
	const edit = form.querySelector('.js-gw-edit');
	const input = form.querySelector('.js-gw-input');

	add.addEventListener('click', (e) => {
		checkbox.checked = true;

		setState('edit');
	});

	save.addEventListener('click', (e) => {
		setState('saved');
		updateAttributes(true, input.value);
	});


	edit.addEventListener('click', (e) => {
		setState('edit');
	});




	close.addEventListener('click', (e) => {
		setState('default');

		// updateAttributes(checkbox.checked, input.value);
	});

	input.addEventListener('input', (e) => {
		if(input.value != '' && checkbox.checked) {
			setState('edit-apply');
		} else {
			// setState('edit');
		}
	});

	checkbox.addEventListener('change', (e) => {
		console.log('checkbox state changed');
		console.log(checkbox.checked);

		if(checkbox.checked) {
			setState('no-error');

			if(input.value != '') {
				setState('edit-apply');
			}

			updateAttributes(true, input.value);
		} else {
			updateAttributes(false);

			if(form.classList.contains('gw--edit')) {
				setState('error');
			}
		}
	});



	function setState(state) {
		const form = document.querySelector('.gw');

		switch (state) {
			case 'edit':
				form.classList.add('gw--edit');
				form.classList.remove('gw--saved');

				if (input.value == ''){
					form.classList.remove('gw--edit-apply');
				}
				break;

			case 'edit-apply':
				form.classList.add('gw--edit-apply');
				form.classList.remove('gw--error');
				break;

			case 'default':
				form.classList.remove('gw--edit', 'gw--error');
				break;

			case 'saved':
				form.classList.remove('gw--edit', 'gw--edit-apply', 'gw--error');
				form.classList.add('gw--saved');

				break;


			case 'error':
				form.classList.add('gw--error');
				break;

				case 'no-error':
				form.classList.remove('gw--error');
				break;


			default:
				break;
		}




	}


	async function updateAttributes(isWrap, message) {
		console.log('updateAttributes()');
		console.log({isWrap, message});

		let attrs = {};

		if(isWrap) {
			attrs['Gift wrap'] = 'Yes';
			if(message) {
				attrs['Gift message'] = message;
			} else {
				attrs['Gift message'] = '';
			}

		} else {
			attrs['Gift wrap'] = '';
			attrs['Gift message'] = '';
		}

		let data = {
			attributes: attrs
		};

		let response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8'
			},
			body: JSON.stringify(data)
		});
	}
}